import { jsx } from 'react/jsx-runtime';
import { styled, alpha } from '@mui/material';

const SIDEBAR_FOOTER_HEIGHT = 80;
function Footer({ children, sx }) {
    return jsx(Wrapper, { sx: sx, children: children });
}
const Wrapper = styled("footer")(({ theme }) => {
    const borderColor = alpha(theme.palette.ui12, 0.1);
    return {
        height: SIDEBAR_FOOTER_HEIGHT,
        borderTop: `1px solid ${borderColor}}`,
        padding: theme.spacing(0, 3),
        top: 0,
    };
});

export { Footer, SIDEBAR_FOOTER_HEIGHT };
//# sourceMappingURL=Footer.js.map
